module.exports = __webpack_public_path__ + "img/consulta-ja-logo.a6783126.svg";